import { supabase } from './supabaseClient';

interface GenerateArgs {
  prompt: string;
  context?: { role: 'user' | 'assistant'; content: string }[];
  framework?: string;
  tier?: 'fast' | 'deep';
  tool?: 'chatgpt' | 'claude' | 'gemini';
}

export async function generateAIResponse({ prompt, context = [], framework = 'CUSTOM', tier = 'fast', tool = 'chatgpt' }: GenerateArgs): Promise<string> {
  const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-response`;
  const { data: { session } } = await supabase.auth.getSession();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY || '',
    'Authorization': `Bearer ${session?.access_token || import.meta.env.VITE_SUPABASE_ANON_KEY || ''}`,
  };
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ prompt, context, framework, tier, tool }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'AI request failed');
  }
  const data = await res.json();
  return data.response || '';
}

export function fillTemplate(template: string, vars: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (_, k) => vars[k] || `{${k}}`);
}
